import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "success",
  "use": "success-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"success\"><defs><style type=\"text/css\"></style></defs><path d=\"M443.733333 785.066667l-68.266666-68.266667-204.8-204.8 68.266666-68.266667 204.8 204.8L819.2 307.2l68.266667 68.266667-443.733334 409.6z m68.266667-785.066667C229.239467 0 0 229.2736 0 512c0 282.760533 229.239467 512 512 512 282.794667 0 512-229.239467 512-512 0-282.760533-229.205333-512-512-512z\" p-id=\"4983\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id